import { defineMessages } from 'react-intl';

/** Copy of Settings → Artist → Time zone (the row pattern of Settings → Account → Language). */
export const timeZoneMessages = defineMessages({
  title: { id: 'app.sml.settings.artist.timeZone.title', defaultMessage: 'Time zone' },
  hint: {
    id: 'app.sml.settings.artist.timeZone.hint',
    defaultMessage:
      "Post times in the release plan and 'release day' publishing use this time zone. Posts that already have a time keep it.",
  },
  current: { id: 'app.sml.settings.artist.timeZone.current', defaultMessage: 'Now: {zone}' },
  notSet: {
    id: 'app.sml.settings.artist.timeZone.notSet',
    defaultMessage: 'Not set yet. This device uses {zone}. Save it to use it for this artist.',
  },
  notSetNoDevice: {
    id: 'app.sml.settings.artist.timeZone.notSetNoDevice',
    defaultMessage: 'Not set yet. Release plan times use UTC until you save a time zone.',
  },
  search: { id: 'app.sml.settings.artist.timeZone.search', defaultMessage: 'Search time zones' },
  searchPlaceholder: {
    id: 'app.sml.settings.artist.timeZone.searchPlaceholder',
    defaultMessage: 'Search, for example Warsaw',
  },
  noMatch: { id: 'app.sml.settings.artist.timeZone.noMatch', defaultMessage: 'No time zone matches "{query}".' },
  useDevice: {
    id: 'app.sml.settings.artist.timeZone.useDevice',
    defaultMessage: "Use this device's time zone ({zone})",
  },
  save: { id: 'app.sml.settings.artist.timeZone.save', defaultMessage: 'Save time zone' },
});
